import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../apis";
import { useCookies } from "react-cookie";

export default function () {
    const [redirect, setRedirect] = useState("verifying")

    const [cookie, setCookie] = useCookies(["access_token"]);

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    useEffect(() => {
        api.get(`/confirm-email-receive-invoice?token=${params.get('token')}`,
            {
                headers: {
                    Authorization: `Bearer ${cookie['access_token']}`,
                },
            }
        ).then(response => {
            setRedirect("success")
        }).catch(error => {
            setRedirect("failed")
        })
    }, [])

    return (
        <>
            {redirect === "success"
                ? "You can safely close this page!"
                : (redirect === "verifying" ? "Verifying your email..." : "Cannot verify receive invoice email. Try again later!")
            }
        </>
    )
}